import * as yup from "yup";

const model = {
  departureTime: "",
  arrivalTime: "",
  // checkInBaggage: "",
  seat: "",
  pnr: "",
  adultBaseFare: 0,
  adultYQ: 0,
  adultTotalTaxPerSeat: 0,
  childBaseFare: 0,
  childYQ: 0,
  childTotalTaxPerSeat: 0,
  infrantBaseFare: 0,
  infrantYQ: 0,
  infrantTotalTaxPerSeat: 0,
  refundable: false,
  isActive:false
};

const validationEditModel = yup.object().shape({
  departureTime: yup.string().required("Please enter departure time"),
  arrivalTime: yup.string().required("Please enter arrival time"),
  // checkInBaggage: yup.string().required("Please enter check in baggage"),
  seat: yup.string().required("Please enter seats"),
  pnr: yup.string().optional(),
  adultBaseFare: yup.number().required("Please Enter Adult Base Fare"),
  adultYQ: yup.number().required("Please Enter Adult YQ"),
  adultTotalTaxPerSeat: yup
    .number()
    .required("Please Enter Adult Total Tax Fare"),
  childBaseFare: yup.number().required("Please Enter Child Base Fare"),
  childYQ: yup.number().required("Please Enter Child YQ"),
  childTotalTaxPerSeat: yup.number().required("Please Enter Child Total Tax"),
  infrantBaseFare: yup.number().required("Please Enter Infant Base Fare"),
  infrantYQ: yup.number().required("Please Enter Infant YQ"),
  infrantTotalTaxPerSeat: yup
    .number()
    .required("Please Enter Infrant TotalTaxPer"),
  refundable: yup.boolean().nullable(),
  isActive:yup.boolean().nullable()
});

export { model, validationEditModel };
